import React from 'react';

const BrandAnalysisExample = () => {
  // Sample data matching your screenshot
  const brandData = [
    { name: 'Apple', sales: '$7.20M', growth: '↑ 6.8%', products: 87, categories: ['Electronics', 'Beauty'] },
    { name: 'Samsung', sales: '$6.80M', growth: '↑ 7.2%', products: 342, categories: ['Electronics', 'Home Appliances'] },
    { name: 'Toyota', sales: '$5.80M', growth: '↑ 2.7%', products: 187, categories: ['Automobile'] },
    { name: 'IKEA', sales: '$4.80M', growth: '↑ 3.2%', products: 1765, categories: ['Furniture'] },
    { name: 'Nike', sales: '$4.10M', growth: '↑ 8.7%', products: 876, categories: ['Clothing', 'Sports Equipment', 'Footwear'] },
  ];

  return (
    <div style={{ padding: '20px', background: 'var(--main-content-bg)', minHeight: '100vh' }}>
      {/* Header */}
      <div className="content-card">
        <div className="section-header">
          <h1 className="section-title">Brand Analysis</h1>
          <p className="section-subtitle">
            Analyze brand performance across different product categories. Compare sales, growth, and product distribution.
          </p>
        </div>
        
        {/* Filter Controls */}
        <div className="filter-bar">
          <div className="filter-group">
            <label className="filter-label">Product Category</label>
            <select className="form-control" style={{ minWidth: '200px' }}>
              <option>All Categories</option>
              <option>Electronics</option>
              <option>Automobile</option>
              <option>Furniture</option>
              <option>Clothing</option>
            </select>
          </div>
          
          <div className="filter-group">
            <label className="filter-label">Performance Metric</label>
            <select className="form-control" style={{ minWidth: '180px' }}>
              <option>Total Sales (USD)</option>
              <option>Growth Rate</option>
              <option>Product Count</option>
              <option>Market Share</option>
            </select>
          </div>
          
          <button className="btn btn-outline">↑ Pack Up One Level</button>
        </div>
        
        <p style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>
          Current View: <strong>All Brands</strong> (Showing 15 brands)
        </p>
      </div>

      {/* Chart Section */}
      <div className="content-card">
        <div className="chart-header">
          <h2 className="chart-title">Brand Performance Distribution</h2>
          <h3 style={{ fontSize: '16px', fontWeight: '600', color: 'var(--text-primary)', marginBottom: '16px' }}>
            Top 10 Brands by Sales
          </h3>
        </div>
        
        {/* Chart Type Tabs */}
        <div className="chart-controls">
          <button className="chart-tab active">Pie Chart</button>
          <button className="chart-tab">Bar Chart</button>
          <button className="chart-tab">Line Chart</button>
        </div>
        
        {/* Mock Chart Area */}
        <div style={{ 
          height: '300px', 
          background: '#f8f9fa', 
          border: '1px solid var(--card-border)', 
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'var(--text-secondary)',
          marginBottom: '20px'
        }}>
          📊 Chart Component Would Go Here
        </div>
      </div>

      {/* Brand Performance Table */}
      <div className="content-card">
        <div className="chart-header">
          <h2 className="chart-title">Brand Performance Details</h2>
        </div>
        
        <table className="table">
          <thead>
            <tr>
              <th>Brand Name</th>
              <th>Total Sales</th>
              <th>Growth</th>
              <th>Product Count</th>
              <th>Categories</th>
            </tr>
          </thead>
          <tbody>
            {brandData.map((brand, index) => (
              <tr key={index}>
                <td>
                  <strong>{brand.name}</strong>
                </td>
                <td>
                  <span className="metric-value" style={{ fontSize: '16px' }}>
                    {brand.sales}
                  </span>
                </td>
                <td>
                  <span className={brand.growth.includes('↑') ? 'growth-positive' : 'growth-negative'}>
                    {brand.growth}
                  </span>
                </td>
                <td>
                  {brand.products.toLocaleString()}
                </td>
                <td>
                  {brand.categories.map((category, catIndex) => (
                    <span key={catIndex} className="badge" style={{ marginRight: '4px' }}>
                      {category}
                    </span>
                  ))}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BrandAnalysisExample;